import React, { useState } from 'react';
import { useScroll } from 'react-use';
import { FakeHeaderTable, StickyHeaderWrapper } from './styled';
import { useStickyHeader } from './utils/hooks';
export const StickyHeader = ({ renderHeader, tableRef, wrapperRef, isFixedLayout, wrapperStyle, }) => {
    var _a;
    const [headerWrapperRef, setHeaderWrapperRef] = useState(null);
    const { isSticky } = useStickyHeader(tableRef, parseInt(typeof (wrapperStyle === null || wrapperStyle === void 0 ? void 0 : wrapperStyle.top) === 'string' ? wrapperStyle === null || wrapperStyle === void 0 ? void 0 : wrapperStyle.top : `${wrapperStyle === null || wrapperStyle === void 0 ? void 0 : wrapperStyle.top}`, 10));
    // here we use 2, because we also have borders on each side by 1 px
    const wrapperWidth = (((_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width) || 0) - 2;
    // we use it just to re-render header to update scroll
    // so we don't need to get any value from this hook
    useScroll(wrapperRef);
    const updateScroll = (ref) => {
        var _a;
        const scrollLeft = ((_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.scrollLeft) || 0;
        if (ref) {
            // eslint-disable-next-line no-param-reassign
            ref.scrollLeft = scrollLeft;
            return;
        }
        if (headerWrapperRef)
            headerWrapperRef.scrollLeft = scrollLeft;
    };
    updateScroll();
    return isSticky ? (React.createElement(StickyHeaderWrapper, { ref: (ref) => {
            setHeaderWrapperRef(ref);
            updateScroll(ref);
        }, style: Object.assign({ width: wrapperWidth }, wrapperStyle) },
        React.createElement(FakeHeaderTable, { style: { tableLayout: isFixedLayout ? 'fixed' : 'auto' } }, renderHeader()))) : null;
};
//# sourceMappingURL=StickyHeader.js.map